import { useContext } from "react";
import { MakeABookingDialogContext } from "./MakeABookingDialogProvider";
import type { MakeABookingDialogState } from "./types";

export const useMakeABookingDialog = (): MakeABookingDialogState => {
  const context = useContext(MakeABookingDialogContext);
  if (!context) {
    throw new Error("useMakeABookingDialog must be used within a MakeABookingDialogProvider");
  }
  return context;
};

export default useMakeABookingDialog;
